import { Link } from 'react-router-dom'

import { useGetBrandKits } from '@/resolvers/org/brand-kit/query'
import { useCurrentOrgContext } from '@/context/CurrentOrgContext'
import { ORG_APP_ROUTE, ORG_BRAND_KIT_ROUTE, ORG_ROUTE, ORG_TEAM_ROUTE } from '@/shared/constants'

const renderProgressBar = (value: string, total: string, color: string, lightColor: string) => {
  const percentage = total === '∞' ? 60 : (parseInt(value) / parseInt(total)) * 100
  return (
    <div className='h-1 bg-slate-200 dark:bg-slate-700 rounded-full'>
      <div className={`h-full ${lightColor} dark:${color} rounded-full`} style={{ width: `${percentage}%` }} />
    </div>
  )
}

export default function SystemUsageSection() {
  const { data: brandKits } = useGetBrandKits()

  const { currentOrg } = useCurrentOrgContext()
  if (!currentOrg) return null

  return (
    <div className='bg-white dark:bg-slate-800/50 rounded-xl p-6 backdrop-blur-xs border border-slate-200/50 dark:border-slate-700/50 shadow-xs'>
      <h2 className='text-lg font-medium text-slate-900 dark:text-white mb-6'>System Usage</h2>
      <div className='space-y-4'>
        {[
          {
            label: 'Draft Apps',
            value: currentOrg.appCount,
            max: '∞',
            color: 'bg-teal-400',
            lightColor: 'bg-teal-500',
            href: `${ORG_ROUTE}/${currentOrg.id}/${ORG_APP_ROUTE}`,
          },
          {
            label: 'Teams',
            value: currentOrg.teams.length,
            max: '∞',
            color: 'bg-blue-400',
            lightColor: 'bg-blue-500',
            href: `${ORG_ROUTE}/${currentOrg.id}/${ORG_TEAM_ROUTE}`,
          },
          {
            label: 'Brand Kits',
            value: `${(brandKits || []).length}`,
            max: '∞',
            color: 'bg-purple-400',
            lightColor: 'bg-purple-500',
            href: `${ORG_ROUTE}/${currentOrg.id}/${ORG_BRAND_KIT_ROUTE}`,
          },
          {
            label: 'Databases',
            value: currentOrg.dbCount,
            max: '∞',
            color: 'bg-pink-400',
            lightColor: 'bg-pink-500',
            href: `${ORG_ROUTE}/${currentOrg.id}/db`,
          },
          {
            label: 'Logged In Users',
            value: '0',
            max: '∞',
            color: 'bg-emerald-400',
            lightColor: 'bg-emerald-500',
            href: `#`,
          },
          {
            label: 'Updates',
            value: '2',
            max: '1000',
            color: 'bg-cyan-400',
            lightColor: 'bg-cyan-500',
            href: `#`,
          },
        ].map((stat, i) => (
          <Link to={stat.href} key={i} className='block space-y-2'>
            <div className='flex justify-between text-sm'>
              <span className='text-slate-600 dark:text-slate-400'>{stat.label}</span>
              <span className='text-slate-900 dark:text-white'>
                {stat.value}/{stat.max}
              </span>
            </div>
            {renderProgressBar(String(stat.value), String(stat.max), stat.color, stat.lightColor)}
          </Link>
        ))}
      </div>
    </div>
  )
}
